import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Container, Alert, Spinner, Row, Col, Image, Button, Badge } from 'react-bootstrap';
import { LanguageProvider } from '../../core/language-provider';
import { DataManager } from '../../core/data-manager';
import { ResourceManager } from '../../core/resource-manager';
import { Helmet } from 'react-helmet';
import moment from 'moment';
import courseHeaderDefault from '../../assets/course-header.jpg';
import CorsiInEvidenza from '../../components/CorsiInEvidenza';
import Vimeo from '@u-wave/react-vimeo';
import "moment/locale/it";


export default function Event() {

    moment.locale("it");

    const navigate = useNavigate();
    const [errors, setErrors] = useState('');
    const { k } = useParams();
    const id = parseInt(k)

    const [data, setData] = useState(null);
    const [userEvent, setUserEvent] = useState(null);


    useEffect(() => {
        init()
    }, [id]);


    useEffect(() => {
        console.log(moment(data && data.endDatetime).isBefore(moment()))
        console.log(moment(data && data.endDatetime))
        console.log(moment())
    }, [data]);


    async function init() {
        var response = await DataManager.getItem('event', id)
        if (response.success === 1) {
            if (response.body.length) {
                var t = response.body[0]
                console.warn('evento', t)
                setData(t)
            }
            else {
                setErrors(LanguageProvider.get('errors.get'))
                console.warn(response)
                setData({})
            }
        }
        else {
            setErrors(LanguageProvider.get('errors.get'))
            console.warn(response)
        }

        var response = await DataManager.searchItems('event_user', 1, 1, { 'field': 'id', 'order': 'desc' }, '', [], [
            {
                fieldName: 'idEvent',
                type: 'value',
                value: id
            }
        ])
        if (response.success === 1 && response.body.length) {
            setUserEvent(response.body[0])
        }
    }


    async function downloadFile(rD) {
        console.log(rD);
        var url = ResourceManager.getFileUrl(rD, rD.entity)
        window.open(url, '_blank');

    }

    /* async function signInEvent() {
        var resp = await DataManager.insertItem('event_user', { idEvent: data.id, registered: '1' })
        if (resp.success === 1) {
            init()
        }
    } */

    async function goToEvent(link) {
        if (userEvent) {
            var resp = await DataManager.updateItem('event_user', { participated: '1' }, userEvent.id)
            if (resp.success === 1) {
                init()
            }
        } else {
            var resp = await DataManager.insertItem('event_user', { idEvent: data.id, registered: '1', participated: '1' })
            if (resp.success === 1) {
                init()
            }
        }

        window.open(link, '_blank');
    }

    function shareEvent() {
        const linkPage = window.location.href;
        navigator.clipboard.writeText(linkPage).then(() => {
            alert("Link copiato negli appunti!");
        })
            .catch((err) => {
                console.error("Errore nella copia del link:", err);
            })
    }

    function addToCalendar() {
        const eventInfo = {
            title: data.name,
            description: data.name,
            location: "Meet",
            start: new Date(data.startDatetime),  // January 30, 2025, 9:00 AM UTC
            end: new Date(data.endDatetime)     // January 30, 2025, 10:00 AM UTC
        };
        downloadICS(eventInfo)
    }

    function downloadICS({
        title,
        description,
        location,
        start,         // JavaScript Date object for the start
        end            // JavaScript Date object for the end
    }) {
        // Helper: Format a Date object as YYYYMMDDTHHMMSSZ (UTC)
        function toISO8601UTC(date) {
            // Convert to UTC string, then replace non-numeric/special chars
            const year = date.getUTCFullYear().toString().padStart(4, '0');
            const month = (date.getUTCMonth() + 1).toString().padStart(2, '0');
            const day = date.getUTCDate().toString().padStart(2, '0');
            const hours = date.getUTCHours().toString().padStart(2, '0');
            const minutes = date.getUTCMinutes().toString().padStart(2, '0');
            const seconds = date.getUTCSeconds().toString().padStart(2, '0');

            return `${year}${month}${day}T${hours}${minutes}${seconds}Z`;
        }

        const dtStamp = toISO8601UTC(new Date()); // Time of creation or modification
        const dtStart = toISO8601UTC(start);
        const dtEnd = toISO8601UTC(end);

        // Create a unique ID (this can be any unique string)
        const uid = `${Date.now()}@yourapp.com`;

        // Construct the ICS file content
        const icsContent = `
      BEGIN:VCALENDAR
      VERSION:2.0
      PRODID:-//YourOrganization//YourApp//EN
      BEGIN:VEVENT
      UID:${uid}
      DTSTAMP:${dtStamp}
      DTSTART:${dtStart}
      DTEND:${dtEnd}
      SUMMARY:${title}
      DESCRIPTION:${description}
      LOCATION:${location}
      END:VEVENT
      END:VCALENDAR
      `.trim(); // .trim() to remove the leading/trailing newlines

        // Blob for the ICS file
        const blob = new Blob([icsContent], { type: 'text/calendar;charset=utf-8' });

        // Create a download link
        const link = document.createElement('a');
        link.href = URL.createObjectURL(blob);
        link.download = 'event.ics'; // The file name for download

        // Programmatically click the link to trigger the download,
        // then revoke the object URL and remove the link from the DOM.
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(link.href);
    }


    function goToEventVideo() {
        window.open(data.videoLink, '_blank');
    }



    if (data) {
        if (data.name) {
            var image = data.idCategory && data.idCategory.image ? ResourceManager.getFileUrl(data.idCategory.image, 'event') : courseHeaderDefault
            return (
                <>
                    <Helmet>
                        <title>Evento</title>
                    </Helmet>

                    <Container fluid style={{ "backgroundImage": `url('${image}')` }} className='course-header-bg p-0'>
                        <div className='course-header-parent'>
                            <Container fluid='md' className=' mb-5 text-light course-header'>

                                {errors.length > 0 &&
                                    <Alert variant='danger'>
                                        {errors}
                                    </Alert>
                                }
                                <Button style={{ border: 0, color: 'white', backgroundColor: 'transparent' }} className='mb-5' onClick={() => window.history.go(-1)}><FontAwesomeIcon icon='arrow-left' className='me-2'></FontAwesomeIcon>{LanguageProvider.get('defaults.back')}</Button>
                                <h4>{moment(data.startDatetime).format("DD MMMM YYYY")}</h4>
                                <h1>{data.name}</h1>

                                <div className='d-flex mt-5'>
                                    <Button onClick={() => { shareEvent() }} style={{ borderRadius: '20px', borderColor: 'white', color: 'white', backgroundColor: 'transparent' }} className='px-3'><FontAwesomeIcon icon='share-nodes' className='me-2'></FontAwesomeIcon>Condividi</Button>
                                </div>

                            </Container>
                        </div>
                    </Container>


                    <Container fluid>
                        <Container fluid='md' className='mt-5 mb-5'>
                            <Row className='justify-content-between'>
                                <Col md={4} xs={12}>
                                    <Row className='align-items-center p-3 mb-3' style={{ backgroundColor: '#f7f7f7', borderRadius: '20px', color: 'var(--primary-color)' }}>
                                        <Col xs={12}>
                                            <h5 className='mb-4'>Download</h5>
                                            {data.documents && data.documents.map(item => {
                                                return (
                                                    <Button key={item.id} variant='light' style={{ borderRadius: '20px', borderColor: 'var(--primary-color)', color: 'var(--primary-color)' }} className='px-3 mb-2 w-100' onClick={() => downloadFile(item.file)}>{item.name}<FontAwesomeIcon icon='download' className='ms-2'></FontAwesomeIcon></Button>
                                                )
                                            })}
                                        </Col>
                                    </Row>
                                    <Row className='align-items-center p-3 mb-3' style={{ backgroundColor: '#f7f7f7', borderRadius: '20px', color: 'var(--primary-color)' }}>
                                        <Col xs={12}>
                                            <h5 className='mb-4'>Date</h5>
                                            <p>Data inizio: <b>{moment(data.startDatetime).format('DD-MM-YYYY hh:mm')}</b></p>
                                            <p>Data fine: <b>{moment(data.endDatetime).format('DD-MM-YYYY hh:mm')}</b></p>
                                        </Col>
                                    </Row>
                                </Col>
                                <Col md={7} xs={12}>
                                    <Row className='align-items-center p-3 mb-3' style={{ backgroundColor: '#f7f7f7', borderRadius: '20px', color: 'var(--primary-color)' }}>
                                        <Col xs={12}>
                                            <h5 className='mb-4'>Informazioni Aggiuntive</h5>
                                            <div className='text-black' dangerouslySetInnerHTML={{ __html: data.description }}></div>
                                            <div className='text-center mt-4'>
                                                {moment(data.startDatetime).isAfter(moment().subtract(12, "hour")) ? (
                                                    <>
                                                        {moment(data.endDatetime).isAfter(moment()) ? (
                                                            <Button onClick={() => { goToEvent(data.link) }} style={{ borderRadius: '20px', backgroundColor: 'var(--primary-color)' }} className='px-3 me-2'><FontAwesomeIcon icon='ticket' className='me-2'></FontAwesomeIcon>Partecipa ora</Button>
                                                        ) : null}
                                                        {/* {userEvent && userEvent.registered ? (
                                                            <Button onClick={() => { goToEvent(data.link) }} style={{ borderRadius: '20px', backgroundColor: 'var(--primary-color)' }} className='px-3 me-2'><FontAwesomeIcon icon='ticket' className='me-2'></FontAwesomeIcon>Partecipa ora</Button>
                                                        ) : (
                                                            <Button onClick={() => { signInEvent() }} style={{ borderRadius: '20px', backgroundColor: 'var(--primary-color)' }} className='px-3 me-2'><FontAwesomeIcon icon='ticket' className='me-2'></FontAwesomeIcon>Iscriviti ora</Button>
                                                        )} */}
                                                        <Button onClick={() => { shareEvent() }} variant='light' style={{ borderRadius: '20px', borderColor: 'var(--primary-color)', color: 'var(--primary-color)' }} className='px-3 me-2'><FontAwesomeIcon icon='share-nodes' className='me-2'></FontAwesomeIcon>Condividi</Button>
                                                        <Button onClick={() => { addToCalendar() }} variant='light' style={{ borderRadius: '20px', borderColor: 'var(--primary-color)', color: 'var(--primary-color)' }} className='px-3'><FontAwesomeIcon icon='calendar' className='me-2'></FontAwesomeIcon>Salva a calendario</Button>
                                                    </>
                                                ) : (
                                                    <>
                                                        {data.videoLink ? (<>
                                                            <p className='small text-primary'>Questo evento è concluso, guarda la registrazione di seguito.</p>
                                                            <div style={{ width: '100%' }}>
                                                                {data.videoLink.includes("vimeo") ? (
                                                                    <>
                                                                        <Vimeo
                                                                            video={data.videoLink}
                                                                            autoplay
                                                                            width="100%"
                                                                            responsive={true}
                                                                        />
                                                                    </>

                                                                ) : (
                                                                    <Button onClick={() => { goToEventVideo() }} variant='light' style={{ borderRadius: '20px', borderColor: 'var(--primary-color)', color: 'var(--primary-color)' }} className='px-3'><FontAwesomeIcon icon='play' className='me-2'></FontAwesomeIcon>Visualizza video</Button>
                                                                )}
                                                            </div>
                                                        </>
                                                        ) : <p className='small text-primary'>Qesto evento è concluso, la registrazione dello stesso non è al momento disponibile.</p>}
                                                    </>
                                                )}
                                            </div>
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                        </Container>
                    </Container>

                    <CorsiInEvidenza />

                </>
            )
        }
        else {
            return (
                <>
                    <Helmet>
                        <title>Evento non trovato</title>
                    </Helmet>

                    <Container fluid='md' className='mt-5 mb-5 text-secondary'>
                        <h3>Evento non trovato</h3>

                        {errors.length > 0 &&
                            <Alert variant='danger'>
                                {errors}
                            </Alert>
                        }

                    </Container>
                </>
            )
        }
    }
    else {
        return (
            <Container fluid="md" className='mt-5 mb-5'>
                {errors.length > 0 &&
                    <Alert variant='danger'>
                        {errors}
                    </Alert>
                }
                <div className='text-center p-5'>
                    <Spinner animation="border" variant="primary" />
                    <p className='text-primary'>{LanguageProvider.get('defaults.loading')}</p>
                </div>
            </Container>
        )
    }
};
